<script>
    import { getContext } from 'svelte';
    import NewInivte from './popups/NewInivte/container.svelte';
    import NewInivteForm from './popups/NewInivte/content.svelte';
    export let subscription;
  
    const { open, close } = getContext('simple-modal');
    const showPopup = (event) => {
        event.stopPropagation();
          open(NewInivte,
            {
                message: "We'll give you an invite link and a message to share with your friend",
            },
            {
                // closeButton: CloseButton,
                form: NewInivteForm,
                propsForForm: [subscription]
            }
        );
      };
</script>

<a
    href={'#'}
    class="new-invite-link" 
    on:click={showPopup}>
        Invite a friend
</a>

<style>
    .new-invite-link {
        font-size: 14px;
    }
</style>